<div class="no-results" [class.mobile]="topService.isMobile">
	<div class="no-results-title">{{ title }}</div>
	<div class="no-results-message">{{ message }}</div>
	<a class="no-results-btn" (click)="clickEvent()">{{ buttonText }}</a>
</div>